export const RESET_STATE = "RESET_STATE";
export const SET_DATA = "SET_DATA";
export const SELECT_DEVICES_CURRENT_COMPANY = "SELECT_DEVICES_CURRENT_COMPANY";
export const SET_ACTIVE_MAP_DATA = "SET_ACTIVE_MAP_DATA";
export const SET_CURRENT_ITEM = "SET_CURRENT_ITEM";
export const SET_CURRENT_ITEM_LOGS = "SET_CURRENT_ITEM_LOGS";
export const SET_CURRENT_ITEM_ADDRESS = "SET_CURRENT_ITEM_ADDRESS";
export const SET_GEO_MAP = "SET_GEO_MAP";
export const SET_ACTIVE_BADGE = "SET_ACTIVE_BADGE";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_LOAD_DATA = "SET_LOAD_DATA";
export const HIDE_BADGE = "HIDE_BADGE";
export const SORT_BY_CENTRE_SEARCH_MAP  = "SORT_BY_CENTRE_SEARCH_MAP";
export const FINDING_NEAR_POINT_MAP  = "FINDING_NEAR_POINT_MAP";
export const CREATE_DUBL_POINT  = "CREATE_DUBL_POINT";
export const UPDATE_DEVICE_INFO  = "UPDATE_DEVICE_INFO";
export const SET_CURRENT_ITEM_CHANGE_ACTIVE  = "SET_CURRENT_ITEM_CHANGE_ACTIVE";
export const CLEAR_CURRENT_ITEM  = "CLEAR_CURRENT_ITEM";
export const SET_CURRENT_ITEM_LOADER_LOGS  = "SET_CURRENT_ITEM_LOADER_LOGS";
export const UPDATE_ALL_DEVICES_SUB_INFO  = "UPDATE_ALL_DEVICES_SUB_INFO";

export function resetStatePage(data) {
    return {
        type: RESET_STATE,
        data
    }
}

export function setData(data) {
    return {
        type: SET_DATA,
        data
    }
}

export function selectDevicesCurrentCompany(data) {
    return {
        type: SELECT_DEVICES_CURRENT_COMPANY,
        data
    }
}

export function setActiveMapData(data) {
    return {
        type: SET_ACTIVE_MAP_DATA,
        data
    }
}

export function setCurrentItem(data) {
    return {
        type: SET_CURRENT_ITEM,
        data
    }
}

export function setCurrentItemLogs(data) {
    return {
        type: SET_CURRENT_ITEM_LOGS,
        data
    }
}

export function setCurrentItemAddress(data) {
    return {
        type: SET_CURRENT_ITEM_ADDRESS,
        data
    }
}

export function setGeoMap(data) {
    return {
        type: SET_GEO_MAP,
        data
    }
}

export function setActiveBadge(data) {
    return {
        type: SET_ACTIVE_BADGE,
        data
    }
}

export function setActiveTab(data) {
    return {
        type: SET_ACTIVE_TAB,
        data
    }
}

export function hideBadge(data) {
    return {
        type: HIDE_BADGE,
        data
    }
}

export function sortByCentreSearchMap(data) {
    return {
        type: SORT_BY_CENTRE_SEARCH_MAP,
        data
    }
}

export function findingNearPointMap(data) {
    return {
        type: FINDING_NEAR_POINT_MAP,
        data
    }
}

export function createDublPoint(data) {
    return {
        type: CREATE_DUBL_POINT,
        data
    }
}

export function updateDeviceInfo(data) {
    return {
        type: UPDATE_DEVICE_INFO,
        data
    }
}

export function setCurrentItemChangeActive(data) {
    return {
        type: SET_CURRENT_ITEM_CHANGE_ACTIVE,
        data
    }
}

export function setCurrentItemLoaderLogs(data) {
    return {
        type: SET_CURRENT_ITEM_LOADER_LOGS,
        data
    }
}

export function clearCurrentItem(data) {
    return {
        type: CLEAR_CURRENT_ITEM,
        data
    }
}

export function updateAllDevicesSubInfo(data) {
    return {
        type: UPDATE_ALL_DEVICES_SUB_INFO,
        data
    }
}

export function setLoadData(data) {
    return {
        type: SET_LOAD_DATA,
        data
    }
}